import {
  Card,
  CardBody,
  Input,
  Table,
  TableCell,
  TableContainer,
  TableHeader,
  Button,
} from "@windmill/react-ui";
import { Tabs, Tab } from "@mui/material";
import TripadvanceTable from "components/tripadvanceapprovaltrans/TripadvanceTable";
import DataWrapper from "./DataWrapper";
import NotFound from "components/table/NotFound";
import PageTitle from "components/Typography/PageTitle";
import useFilter from "hooks/useFilter";
import { useState, useEffect, useContext } from "react";
import TripadvanceServices from "services/TripadvanceServices";
import { FiRefreshCcw } from "react-icons/fi";
import DeleteModal from "components/modal/DeleteModal";
import useToggleDrawer from "hooks/useToggleDrawer";
import { SidebarContext } from "context/SidebarContext";

import sidebar from "routes/sidebar";
import LabelArea from "components/form/LabelArea";
import InputSearchDate from "components/form/InputSearchDate";

const Tripadvance = () => {
  const adminInfo = localStorage.getItem("adminInfo")
    ? JSON.parse(localStorage.getItem("adminInfo"))
    : null;
  const id_employee = adminInfo?.id ? adminInfo.id : 0;
  const [loading, setLoading] = useState(false);
  const { isUpdate, setIsUpdate } = useContext(SidebarContext);
  const { title, serviceId } = useToggleDrawer();
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [tab, setTab] = useState(0);
  const [error, setError] = useState(false);
  const [tripadvanceData, setTripadvanceData] = useState([]);
  const [status, setStatus] = useState(false);

  const {
    tripadvanceRef,

    dataTable,
    serviceData,
    handleSubmitTripadvance,
    currentPage,
  } = useFilter(tripadvanceData, itemsPerPage);

  useEffect(() => {
    if (serviceData.length !== 0) {
      setItemsPerPage(serviceData.length);
    }
  }, [serviceData]);

  const groupedData = tripadvanceData.reduce((acc, row) => {
    // Generate a normalized key by trimming and converting to lowercase
    const key = `${row.ref_no?.trim().toLowerCase()}-${row.client_name
      ?.trim()
      .toLowerCase()}-${row.vendor_name
      ?.trim()
      .toLowerCase()}-${row.start_date?.trim()}-${row.arrival
      ?.trim()
      .toLowerCase()}-${row.departure?.trim().toLowerCase()}-${row.vehicle_type
      ?.trim()
      .toLowerCase()}`;

    if (!acc[key]) {
      // Create a new group if the key does not exist
      acc[key] = {
        ...row,
        trip_advance_request: [row.trip_advance_request], // Store requests in an array
        approval_status: [row.approval_status],
        approved_remark: [row.approved_remark],
        paid_status: [row.paid_status], // Store paid amounts in an array
        restrict_amount: [row.restrict_amount],
        id: [row.id],
        trip_advance_paid: [row.trip_advance_paid],
        payment_type: [row.payment_type],
        utr: [row.utr],
        paid_date: [row.paid_date],
        paid_remark: [row.paid_remark],
      };
    } else {
      // Push the new values to the existing arrays
      acc[key].trip_advance_request.push(row.trip_advance_request);
      acc[key].paid_status.push(row.paid_status);
      acc[key].approval_status.push(row.approval_status);
      acc[key].approved_remark.push(row.approved_remark);
      acc[key].restrict_amount.push(row.restrict_amount);
      acc[key].id.push(row.id);
      acc[key].trip_advance_paid.push(row.trip_advance_paid);
      acc[key].payment_type.push(row.payment_type);
      acc[key].utr.push(row.utr);
      acc[key].paid_date.push(row.paid_date);
      acc[key].paid_remark.push(row.paid_remark);
    }

    return acc;
  }, {});
  // Assuming groupedData is already defined as in your code
  for (const refNo in groupedData) {
    if (groupedData.hasOwnProperty(refNo)) {
      // const tripAdvanceRequestArray = groupedData[refNo].trip_advance_request;
      // Calculate the total of all trip_advance_request values for this ref_no
      // const totalTripAdvanceRequest = tripAdvanceRequestArray.reduce(
      //   (sum, amount) => sum + amount,
      //   0
      // );
    }
  }

  // const groupedArray = Object.values(groupedData);

  const [searchstartDate, setSearchStartDate] = useState(null);
  const [searchendDate, setSearchEndDate] = useState(null);
  const formatDate = (date) => {
    if (!date) return null;
    const d = new Date(date);
    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const year = d.getFullYear();
    return `${day}-${month}-${year}`;
  };
  const formattedDates = {
    start_date: searchstartDate ? formatDate(searchstartDate) : "",
    end_date: searchendDate ? formatDate(searchendDate) : "",
  };

  // const totalResults = groupedArray.length;

  useEffect(() => {
    const fetchTripadvance = async () => {
      setLoading(true);
      var date = {
        from: formattedDates.start_date,
        to: formattedDates.end_date,
      };
      try {
        let response;
        if (tab === 0) {
          response = await TripadvanceServices.getTripadvanceList(2, date);
        } else if (tab === 1) {
          response = await TripadvanceServices.getTripadvanceList(4, date);
        }

        // Backend already returns one entry per booking+vendor with the actual
        // per-request fields (trip_advance_request, trip_advance_paid, id,
        // approval_status, status, restrict_amount, etc.) nested inside
        // trip_advances[] — TripadvanceTable (the row renderer) reads that
        // array directly (data.trip_advances), so pass it through as-is.
        const updatedData = response?.data || [];
        setTripadvanceData(updatedData);
        setStatus(response?.status);
        setLoading(false);
      } catch (error) {
        setLoading(false);
        setError(true);
        console.error("Error fetching tripadvance:", error);

        // notifyError("Failed to fetch tripadvance. Please try again later.");
      }
    };
    fetchTripadvance();
    setIsUpdate(false);
    // eslint-disable-next-line
  }, [tab, isUpdate]);

  const handleTabChange = (event, newValue) => {
    setTab(newValue);
  };

  const handleSearch = () => {
    setIsUpdate(true);
  };

  const isAdmin = adminInfo?.id === 1;

  const hideView = isAdmin
    ? true
    : adminInfo?.permission?.some(
        (perm) => perm.id_tab === "trip advance approval" && perm.view === 1,
      );

  const hideEdit = isAdmin
    ? true
    : adminInfo?.permission?.some(
        (perm) => perm.id_tab === "trip advance approval" && perm.eidt === 1,
      );

  const handleRefresh = () => {
    setIsUpdate(true);
  };

  return (
    <>
      {hideView && (
        <>
          <DeleteModal id={serviceId} title={title} />

          <PageTitle sidebar={sidebar().sidebar} />
          <Card className="min-w-0 shadow-xs overflow-hidden bg-white dark:bg-gray-800">
            <CardBody>
              <div className="flex flex-wrap items-center gap-3">
                <div className="flex items-center gap-3">
                  <div className="flex items-center gap-2">
                    <LabelArea label="From" />
                    <div className="w-50">
                      <InputSearchDate
                        value={searchstartDate}
                        onChange={(event) => setSearchStartDate(event)}
                      />
                    </div>
                  </div>

                  <div className="flex items-center gap-2">
                    <LabelArea label="To" />
                    <div className="w-50">
                      <InputSearchDate
                        value={searchendDate}
                        min={searchstartDate}
                        onChange={(event) => setSearchEndDate(event)}
                      />
                    </div>
                  </div>
                </div>

                <div className="flex-1">
                  <Input
                    ref={tripadvanceRef}
                    className="border h-10 text-sm focus:outline-none block w-full bg-gray-100 border-transparent focus:bg-white"
                    type="search"
                    name="search"
                    autoComplete="off"
                    placeholder="Quick Search"
                    onChange={handleSubmitTripadvance}
                  />
                </div>

                <div>
                  <Button
                    className="rounded-md h-10 px-8"
                    onClick={() => {
                      handleSearch();
                    }}
                  >
                    Search
                  </Button>
                </div>
                <FiRefreshCcw
                  onClick={() => {
                    handleRefresh();
                  }}
                  cursor="pointer"
                />
              </div>
            </CardBody>
          </Card>
          <Tabs
            value={tab}
            onChange={handleTabChange}
            TabIndicatorProps={{
              style: { backgroundColor: "#057a55" },
            }}
            sx={{
              "& .MuiTab-root": {
                textTransform: "capitalize",
              },
            }}
          >
            {/* <Tab label="All" /> */}

            <Tab
              className="focus:outline-none dark:text-white"
              sx={{ "&.Mui-selected": { color: "#057a55", outline: "none" } }}
              label="Approval"
            />
            <Tab
              className="focus:outline-none dark:text-white"
              sx={{ "&.Mui-selected": { color: "#057a55", outline: "none" } }}
              label="Status"
            />
          </Tabs>
          <DataWrapper loading={loading} error={error} status={status}>
            {serviceData?.length !== 0 ? (
              <TableContainer>
                <div
                  className="overflow-y-scroll"
                  style={{ maxHeight: "67vh", scrollbarWidth: "thin" }}
                >
                  <Table>
                    <TableHeader className="capitalize z-10 text-center sticky top-0 text-sm">
                      <tr>
                        <TableCell>Sl.No.</TableCell>
                        <TableCell>Ref No.</TableCell>
                        <TableCell>Client Name </TableCell>
                        <TableCell>Trip Date</TableCell>
                        <TableCell>Arrival / Departure</TableCell>
                        <TableCell>No of Days</TableCell>
                        <TableCell>Vehicle Type</TableCell>
                        {tab === 0 && <TableCell>Itinerary</TableCell>}
                        <TableCell>Vendor Name</TableCell>
                        <TableCell>Travel date</TableCell>
                        <TableCell>Advance Request</TableCell>
                        {tab == 0 && <TableCell>Action</TableCell>}
                        {tab == 1 && <TableCell>Status</TableCell>}
                      </tr>
                    </TableHeader>
                    <TripadvanceTable
                      tripadvance={dataTable}
                      perpage={itemsPerPage}
                      currentPage={currentPage}
                      tab={tab}
                      hideEdit={hideEdit}
                    />
                  </Table>
                </div>
              </TableContainer>
            ) : (
              <NotFound title="There are no Trip Advance." />
            )}
          </DataWrapper>
        </>
      )}
    </>
  );
};

export default Tripadvance;
